import type { ReactElement, ReactNode, SVGProps } from 'react'

function iconBase(
  props: SVGProps<SVGSVGElement>,
  children: ReactNode,
  title: string,
): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label={title}
      {...props}
    >
      {children}
    </svg>
  )
}

export function SendIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return iconBase(
    props,
    <>
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22,2 15,22 11,13 2,9 22,2" />
    </>,
    'Send',
  )
}

export function SmileIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return iconBase(
    props,
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
      <line x1="9" y1="9" x2="9.01" y2="9" />
      <line x1="15" y1="9" x2="15.01" y2="9" />
    </>,
    'Smile',
  )
}

export function PaperclipIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return iconBase(
    props,
    <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />,
    'Attach',
  )
}
